import React, { Component } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import lunr from "lunr"

class Search extends Component {
    state = {
        value: ""
    }

    searchIndex = null

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        this.props.onRef(this)
        this.updateIndex()
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    handleChange(event) {
        this.setState({ value: event.target.value })
    }

    handleSearch(event, el) {
        this.search()
        event.preventDefault()
        el.blur()
    }

    handleSubmit(event, el) {
        event.preventDefault()
    }

    search() {
        const { value } = this.state
        const words = value.trim().split(" ").map(word => {
            return word + " *" + word + "*"
        }).join(" ")

        const result = !value.length ? null : this.searchIndex.search(words)

        if ("handleSearch" in this.props) {
            this.props.handleSearch(result)
        }
    }

    render() {
        const { placeholder } = this.props

        return (
            <form onSubmit={this.handleSubmit} className="block relative my-sm">
                <label htmlFor="query" className="absolute left-0 top-1/2 -mt-em-1/2 pl-3 leading-none inline-block">
                    <FontAwesomeIcon icon={["fal", "search"]} />
                    <span className="screen-reader-text">Suche</span>
                </label>
                <input ref={element=>(element||{}).onsearch = (e) => {this.handleSearch(e, element)}} id="query" type="search" value={this.state.value} placeholder={placeholder} onChange={this.handleChange} className="bg-gray-200 rounded-lg block text-base text-gray-900 pl-10 py-2 pr-4 w-full appearance-none" aria-label="Suchbegriff eingeben" />
                <input type="submit" value="Suchen" className="hidden" aria-label="Suche starten" />
            </form>
        )
    }

    updateIndex(index) {
        const { fields } = this.props

        let autoSearch = false

        if (index === undefined) {
            index = this.props.index
        } else {
            autoSearch = true
        }

        this.searchIndex = lunr(function() {
            if (typeof fields === "object") {
                for (let field of fields) {
                    this.field(field)
                }
            } else if (index.length) {
                const firstItem = index[0];
                const keys = Object.keys(firstItem);

                for (let field of keys) {
                    if (field !== "id") {
                        this.field(field)
                    }
                }
            }

            for (let item of index) {
                this.add(item)
            }
        })

        if (autoSearch) {
            this.search()
        }
    }
}

export default Search
